var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTypeRadio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_3009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.41366 1H6.39757C3.4166 1 1 3.41696 1 6.39851C1 9.38007 3.4166 11.7971 6.39757 11.7971H6.41366C9.39463 11.7971 11.8111 9.38007 11.8111 6.39851C11.8111 3.41696 9.39463 1 6.41366 1Z",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.40885 4.31543H6.40262C5.25245 4.31543 4.32007 5.24799 4.32007 6.39839C4.32007 7.54878 5.25245 8.48134 6.40262 8.48134H6.40885C7.55902 8.48134 8.4914 7.54878 8.4914 6.39839C8.4914 5.24799 7.55902 4.31543 6.40885 4.31543Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0164 6.39844H25.6866",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41366 14.9214H6.39757C3.4166 14.9214 1 17.3383 1 20.3199C1 23.3015 3.4166 25.7185 6.39757 25.7185H6.41366C9.39463 25.7185 11.8111 23.3015 11.8111 20.3199C11.8111 17.3383 9.39463 14.9214 6.41366 14.9214Z",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0164 20.3203H25.6866",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_3009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.6865,
    height: 26.7191,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTypeRadio);
export default __webpack_public_path__ + "static/media/icon_type_radio.b497493faff4d3d2efe6b08e639c50e4.svg";
export { ForwardRef as ReactComponent };